    <template>
      <div class="container mt-5">

        <ValidatorTable/>
      </div>
    </template>

    <script>
    import ValidatorTable from "@/views/comp_table/validator_table";
    export default {
    name: "index",
      components: {ValidatorTable}
    }
    </script>

    <style scoped lang="less">

    </style>
